import React from "react";
import { useTranslation } from "react-i18next";
import { setAppLanguage, getAppLanguage } from "../i18n";
import "./LanguageSwitcher.css";

function LanguageSwitcher({ variant = "compact" }) {
  const { t, i18n } = useTranslation();
  const current = i18n.language || getAppLanguage() || "en";

  const handleChange = (event) => {
    const lang = event.target.value;
    setAppLanguage(lang);
  };

  return (
    <div className={`lang-switcher lang-switcher-${variant}`}>
      <select
        value={current}
        onChange={handleChange}
        aria-label="Select language"
        className="lang-switcher-select"
      >
        <option value="en">{t("lang.english")}</option>
        <option value="rw">{t("lang.kinyarwanda")}</option>
      </select>
    </div>
  );
}

export default LanguageSwitcher;

